module.exports = __webpack_public_path__ + "img/zimilirong.00b7d9d7.jpg";